import React from "react";
import styles from "./styles.module.scss";
import { IoMdCloseCircle } from "react-icons/io";
import { IoMdHome } from "react-icons/io";
import { useChatbotConfig } from "../../../contexts/chatbot-config";

export default function Header({
  setOpen,
}: {
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
}) {
  const { chatbotData } = useChatbotConfig();
  const avatarUrl = chatbotData?.chatbot_icon?.trim();
  const homepageUrl = chatbotData?.homepage_url?.trim();
  const [showLogo, setShowLogo] = React.useState<boolean>(!!avatarUrl);
  
  React.useEffect(() => {
    setShowLogo(!!avatarUrl);
  }, [avatarUrl]);
  
  function handleClick() {
    setOpen(false);
  }
  
  function handleHomeClick() {
    if (homepageUrl) {
      // URLがhttp://またはhttps://で始まらない場合、https://を追加
      let url = homepageUrl;
      if (!url.startsWith('http://') && !url.startsWith('https://')) {
        url = 'https://' + url;
      }
      window.open(url, '_blank');
    }
  }

  const titleStyle = React.useMemo(() => {
    if (chatbotData?.chatbot_title_color) {
      return {
        color: chatbotData.chatbot_title_color
      };
    }
    return {};
  }, [chatbotData?.chatbot_title_color]);

  return (
    <header className={styles.header}>
      <div className={styles.container}>
        <div className={styles.logo}>
          {showLogo && (
            <img
              className={styles.logoImage}
              src={avatarUrl}
              alt=""
              width="32"
              height="32"
              onError={() => setShowLogo(false)}
            />
          )}
          <div className={styles.logoTitleGroup}>
            <div className={styles.logoTitle} style={titleStyle}>
              {chatbotData?.chatbot_title || "One Touch AI Chatbot"}
            </div>
            {chatbotData?.ai_name && (
              <div className={styles.logoSubtitle} style={titleStyle}>
                {chatbotData.ai_name}
              </div>
            )}
          </div>
        </div>
        <div className={styles.buttons}>
          {homepageUrl && (
            <button type="button" className={styles.button} onClick={handleHomeClick}>
              <IoMdHome fill="white" className={styles.buttonIcon} />
            </button>
          )}
          <button type="button" className={styles.button} onClick={handleClick}>
            <IoMdCloseCircle fill="white" className={styles.buttonIcon} />
          </button>
        </div>
      </div>
    </header>
  );
}
